import DownloadView from './Download'

export default function install(Vue) {
  Vue.component('DownloadView', DownloadView)
}
